export default "__VITE_ASSET__de05a37f__"